import { cn } from "@bleu.builders/ui";
import React from "react";

export function ExternalDiagnosisFormHeader({ icon }) {
  return (
    <div className="flex flex-col gap-y-2">
      {icon && (
        <div
          className={cn(
            "rounded-md flex justify-center items-center h-36 px-4 shadow-md border dark:border-2 bg-primary",
          )}
        >
          <img src={icon} className="max-h-24 max-w-full object-contain" />
        </div>
      )}
      <div className="rounded-md border dark:border-2 shadow-md">
        <div className="rounded-t-md h-3 border-b bg-primary"></div>
        <h1 className="pl-5 text-2xl font-semibold text-foreground my-4 text-white">
          Diagnóstico Tributário
        </h1>
      </div>
    </div>
  );
}
